// language.service.ts
import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private renderer: Renderer2;

  constructor(
    private translate: TranslateService,
    rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
    const saved = localStorage.getItem('lang') || 'ar';
    this.setLanguage(saved);
  }

  setLanguage(lang: string): void {
    this.translate.use(lang);
    localStorage.setItem('lang', lang);
    this.renderer.setAttribute(document.documentElement, 'lang', lang);
    this.renderer.setAttribute(
      document.documentElement,
      'dir',
      lang === 'ar' ? 'rtl' : 'ltr'
    );
  }

  getCurrentLang(): string {
    return this.translate.currentLang || 'ar';
  }
}